module.exports = __webpack_public_path__ + "img/navicon_personal.7187ed3f.png";